<template>
  <div id="shopping-cart" class="shopping-cart">
    <h3>Shopping Cart</h3>
    <serviceCart/>
  </div>
</template>

<script>
import serviceCart from "../components/service_cart";

export default {
  name: "shopping-cart",
  components: {
    serviceCart
  }
};
</script>

<style scoped>
.shopping-cart {
  width: 100%;
}
</style>



